<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetSidebarNews } from '~/components/widget/sidebar-news'
import { WidgetSidebarRates } from '~/components/widget/sidebar-rates'
import { WidgetSeoContent } from '~/components/widget/seo'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetFaqList } from '~/components/widget/faq-list'
import { WidgetExchangeOfficeMeiliSearch } from '~/components/widget/exchange-office'

const { t } = useI18n()
const { pathWithoutLocale } = useLocalizedPath()

const breadcrumbs = computed(() => [
  { title: t('common.exchange_offices'), url: '/exchange-offices' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside v-if="!$device.isMobile">
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
            <SidebarBlock variant="white" :heading-text="$t('common.exchange_rates')">
              <WidgetSidebarRates />
            </SidebarBlock>
            <WidgetSidebarNews
              :heading="$t('page.exchange_offices.sidebarNewsHeading')"
              path="/news"
              :query-params="{
                per_page: '5',
                'filter[tag]': 'обмен валют'
              }"
              variant="white"
            />
          </aside>
        </template>
        <div class="space-y-5" role="main">
          <WidgetSeoContent
            position="upper"
            :title="$t('common.exchange_offices')"
            :description="$t('page.exchange_offices.description')"
          />
          <WidgetExchangeOfficeMeiliSearch
            :query-params="{
              per_page: '20'
            }"
          />
          <WidgetSeoContent position="bottom" />
          <WidgetFaqList
            :query-params="{
              'filter[faqable_url]': pathWithoutLocale
            }"
          />
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
